import { h } from "preact";
import { Typography } from "antd";


export default function VerifaceTransactionInfoDataSource(transactionInfo) {

    function asTableView() {
        return {
            columns: [
                {
                    dataIndex: "label",
                },
                {
                    dataIndex: "value",
                    render: (value) => (
                        <Typography.Text
                            type="secondary"
                        >
                            {value}
                        </Typography.Text>
                    ),
                },
            ],
            rows: [
                {
                    label: "Status",
                    value: transactionInfo?.status,
                },
                {
                    label: "Score",
                    value: transactionInfo?.score,
                }
            ]
        };
    }

    function isEmpty() {

        const requiredFields = [
            "status",
            "score"
        ];

        if (!transactionInfo) {
            return true;
        }

        return !requiredFields.every(field => (
            transactionInfo.hasOwnProperty(field)
        ));
    }

    return { asTableView, isEmpty };
}